import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase/firebase';

// Import all necessary components
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import GallerySection from './components/GallerySection';
import Artist from './components/Artist';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';
import Footer from './components/Footer';
import GalleryPage from './components/GalleryPage';

// Import Admin components
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';

const App = () => {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Listen to Firebase auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAdminAuthenticated(true);
      } else {
        setIsAdminAuthenticated(false);
      }
      setLoading(false);
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  const handleAdminLogin = () => {
    setIsAdminAuthenticated(true);
  };

  const handleAdminLogout = async () => {
    try {
      await signOut(auth);
      setIsAdminAuthenticated(false);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <Router>
      <div className='max-w-[1920px] mx-auto overflow-hidden bg-white'>
        <Routes>
          {/* Main Website Routes */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Hero />
                <About />
                <GallerySection />
                <div id="artist">
                  <Artist />
                </div>
                <Testimonial />
                <div id="contact">
                  <Contact />
                </div>
                <div id="footer">
                  <Footer />
                </div>
              </>
            }
          />
          
          <Route 
            path="/gallery" 
            element={
              <>
                <Header />
                <GalleryPage />
                <Footer />
              </>
            } 
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              isAdminAuthenticated ? (
                <AdminDashboard onLogout={handleAdminLogout} />
              ) : (
                <AdminLogin onLogin={handleAdminLogin} />
              )
            }
          />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;